module.exports = __webpack_public_path__ + "static/media/E5213AFB-547A-4FA1-B314-AAF4F51141AD.79e43bd4.bin";